<template>
  <v-card>
    <v-toolbar dark class="primary">
      <v-btn icon @click.native="close" dark>
        <v-icon>fa-times</v-icon>
      </v-btn>
      <v-toolbar-title>{{title}}</v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      <v-container fluid>
        <v-row no-gutters>
          <v-col cols="12">
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-container>
                <v-row no-gutters>
                  <v-col cols="12">
                    <v-text-field label="Nazwa" v-model="nazwa" :rules="[nazwa_rules.required, nazwa_rules.min_length]"></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <v-text-field label="Długość wizyty" v-model.number="dlugosc_wizyty" :rules="[dlugosc_wizyty_rules.numbers, dlugosc_wizyty_rules.min]" type="number"></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field label="Cena (zł)" v-model.number="cena" :rules="[dlugosc_wizyty_rules.numbers]" type="number" @input="handleInput"></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="10">
                    <v-text-field label="Kod ICD9" v-model="kod_icd9" readonly></v-text-field>
                  </v-col>
                  <v-col cols="2">
                    <v-btn color="primary" @click="showAddIcd9 = true">Wybierz kod</v-btn>
                  </v-col>
                </v-row>
                <v-row v-if="$can('do','POKO_Terapeuci_ProwizjaEdycja')">
                  <v-col cols="6">
                    <v-text-field label="Prowizja" v-model="prowizja" :rules="[prowizja_rules.numbers]" type="number" @input="handleCommissionInput"></v-text-field>
                  </v-col>
                </v-row>
                <v-row v-if="$can('do','POKO_Terapeuci_ProwizjaEdycja')">
                  <v-col cols="6">
                    <v-text-field label="Prowizja %" v-model="prowizja_procent" :rules="[prowizja_procent_rules.numbers]" type="number" @input="handlePercentageInput"></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <v-checkbox v-model="aktywna" label="Czy aktywny?" :readonly="this.id == 0"></v-checkbox>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn @click="close" color="error">Zamknij</v-btn>
      <v-btn color="success" @click="save">Zapisz</v-btn>
    </v-card-actions>
    <ICD9PIcker v-if="showAddIcd9" :visible="showAddIcd9" @close="showAddIcd9 = false" @category_selected="categorySelected"></ICD9PIcker>
    <v-overlay :value="loading">
      <v-progress-circular
          indeterminate
          size="64"
      ></v-progress-circular>
    </v-overlay>
  </v-card>

</template>

<script>
import ICD9PIcker from "@/components/visits/ICD9PIcker";
import {therapistsService} from "@/services";
import swal from "sweetalert";
export default {
  name: "TypWizytyEdycja",
  components: {ICD9PIcker},
  props: ["id", "terapeuta_id"],
  data()
  {
    return {
      title: 'Dodawanie typu wizyty',
      nazwa: '',
      cena: 0,
      aktywna: true,
      domyslny_kod_icd9: '',
      domyslny_kod_icd9_opis: '',
      dlugosc_wizyty: 0,
      prowizja: 0,
      prowizja_procent: 0,
      valid: true,
      showAddIcd9: false,
      loading: false,
      nazwa_rules: {
        required: value=> !!value || 'Nazwa jest wymagana',
        min_length: value=> !(value && value.length < 3) || 'Nazwa musi posiadać minimum 3 znaki'
      },
      dlugosc_wizyty_rules: {
        numbers: value => !isNaN(value) || 'Długośc wizyty musi być liczbą całkowita',
        min: value => Number(value) > 0 || 'Długośc wizyty musi być większa od 0'
      },
      cena_rules: {
        numbers: value => !isNaN(value) || 'Cena musi być liczbą',
        min: value => Number(value) > 0 || 'Cena nie może być mniejsza od 0'
      },
      prowizja_rules: {
        numbers: value => !isNaN(value) || 'Prowizja musi być liczbą',
        min: value => Number(value) >= 0 || 'Prowizja nie może być mniejsza od 0'
      },
      prowizja_procent_rules: {
        numbers: value => !isNaN(value) || 'Prowizja % musi być liczbą',
        min: value => Number(value) >= 0 || 'Prowizja % nie może być mniejsza od 0',
        max: value => Number(value) <= 100 || 'Prowizja % nie może być większa od 100'
      }
    }
  },
  mounted() {
    this.getEdytowanyTyp()
  },
  methods: {
    close()
    {
      this.$emit('close')
    },
    categorySelected(cat) {
      this.showAddIcd9 = false
      this.domyslny_kod_icd9 = cat.kod,
      this.domyslny_kod_icd9_opis = cat.opis
    },
    handleInput (e) {
      let stringValue = e
      let regex = /^\d*(\,\d{1,2})?$/
      if(!stringValue.match(regex) && this.cena!== '') {
        this.cena = this.previousPrice
      }
      this.previousPrice = this.cena
    },
    handleCommissionInput (e) {
      if (e < 0) {
        this.prowizja = 0
        return
      }
      this.prowizja = e
      if (e > 0) {
        this.prowizja_procent = 0
      }
    },
    handlePercentageInput (e) {
      if (e < 0) {
        this.prowizja_procent = 0
        return
      }
      if (e > 100) {
        this.prowizja_procent = 100
        return
      }
      this.prowizja_procent = e
      if (e > 0) {
        this.prowizja = 0
      }
    },
    getEdytowanyTyp()
    {

        if(this.id > 0)
        {

          this.loading = true
          therapistsService.GetTypWizyty(this.id).then( result => {
            let itm = result.data.result
            this.cena = itm.cena
            this.nazwa = itm.nazwa
            this.aktywna = itm.aktywna
            this.dlugosc_wizyty = itm.dlugosc_wizyty
            this.domyslny_kod_icd9_opis = itm.domyslny_kod_icd9_opis
            this.domyslny_kod_icd9 = itm.domyslny_kod_icd9
            this.prowizja = itm.prowizja
            this.prowizja_procent = itm.prowizja_procent
            this.loading = false
          }).catch(() => {
            this.showError(true,'Błąd pobierania typu wizyty')
            this.loading = false
          })
        }

    },
    save()
    {
      if(this.$refs.form.validate())
      {
        if(this.id == 0)
        {
          this.loading = true
          therapistsService.InsertTypWizyty({
            terapeuta_id: this.terapeuta_id,
            dlugosc_wizyty: this.dlugosc_wizyty,
            cena: this.cena,
            aktywna: this.aktywna,
            nazwa: this.nazwa,
            domyslny_kod_icd9: this.domyslny_kod_icd9,
            domyslny_kod_icd9_opis: this.domyslny_kod_icd9_opis,
            prowizja: this.prowizja,
            prowizja_procent: this.prowizja_procent
          }).then(() => {
            this.loading = false
            this.$emit('close')
          }).catch(() => {
            this.loading = false
            this.showError(false,'Błąd zapisu typu wizyty')
          })

        }
        else
        {
          this.loading = true
          therapistsService.UpdateTypWizyty({
            id: this.id,
            terapeuta_id: this.terapeuta_id,
            dlugosc_wizyty: this.dlugosc_wizyty,
            cena: this.cena,
            nazwa: this.nazwa,
            aktywna: this.aktywna,
            domyslny_kod_icd9: this.domyslny_kod_icd9,
            domyslny_kod_icd9_opis: this.domyslny_kod_icd9_opis,
            prowizja: this.prowizja,
            prowizja_procent: this.prowizja_procent
          }).then(() => {
            this.loading = false
            this.$emit('close')
          }).catch(() => {
            this.loading = false
            this.showError(false,'Błąd zapisu typu wizyty')
          })
        }
      }
    },
    showError(close, text) {
      swal({
        title: "Błąd",
        text: text,
        icon: "warning",
        button: "OK"
      }).then(() => {
        this.loading = false;
        if (close) {
          this.$emit("close");
        }
      });
    },
  },
  computed: {
    kod_icd9: function() {
      if(this.domyslny_kod_icd9 && this.domyslny_kod_icd9.length > 0)
        return this.domyslny_kod_icd9 + ' - ' +this.domyslny_kod_icd9_opis;
      return '';
    }
  }

}
</script>

<style scoped>

</style>